import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldMapPicker } from '@/(routers)/boards/editor/block/definitions/fields/fieldMapPicker';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = [
    { value: 'UPPER_LEFT', label: '左上' },
    { value: 'UPPER_RIGHT', label: '右上' },
    { value: 'LOWER_LEFT', label: '左下' },
    { value: 'LOWER_RIGHT', label: '右下' },
];

const UNIT_OPTIONS = [
    { value: 'KM', label: 'km' },
    { value: 'M', label: 'm' },
];

defineBlock({
    type: 'gps_distance',
    colour: CATEGORIES.gps.color,
    tooltip: '現在地から指定した場所までの距離を測定します',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/gps.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('GPS', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('距離'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: CATEGORIES.gps.color,
                    options: POSITION_OPTIONS,
                },
                { type: 'label', text: 'で 現在地 から' },
                {
                    type: 'field',
                    name: 'LOCATION',
                    instance: () => new FieldMapPicker(),
                },
                { type: 'label', text: 'までの距離' },
                {
                    type: 'field',
                    name: 'UNIT',
                    instance: () => new FieldOperatorDropdown(UNIT_OPTIONS, 'KM', undefined, CATEGORIES.gps.color),
                },
                { type: 'label', text: 'を測定する ' },
            ],
        },
    ],
});
